import { Router, RouteLocationNormalizedLoaded } from "vue-router";
import { Menu } from "@/ts/interfaces/menu.interface";
import { slideUp, slideDown } from "@/utils/helper";

// @ts-ignore
interface Route extends RouteLocationNormalizedLoaded {
  forceActiveMenu?: string;
}

// @ts-ignore
export interface FormattedMenu extends Menu {
  active?: boolean;
  activeDropdown?: boolean;
  subMenu?: FormattedMenu[];
}

const findActiveMenu = (subMenu: Menu[], route: Route): boolean => {
  let match = false;
  subMenu.forEach((item) => {
    let newPath = item.rec_active_rule;
    const processId = item.rec_target_process_id;
      if(item.rec_active_rule != undefined && item.rec_active_rule.includes(",")) {
        const originalPath = item.rec_active_rule;
        newPath = originalPath.split(",")[0].trim()
      }
    if (
      ((route.forceActiveMenu !== undefined &&
        item.pageName === route.forceActiveMenu) ||
        (route.forceActiveMenu === undefined &&
          // @ts-ignore
          ('/management' + newPath === window.location.pathname || '/management' + newPath + "/" + processId === window.location.pathname))) &&
      !item.ignore
    ) {
      match = true;
    } else if (!match && item.subMenu) {
      match = findActiveMenu(item.subMenu, route);
    }
  });
  return match;
};

const nestedMenu = (menu: Array<Menu | "divider">, route: Route) => {
  const formattedMenu: Array<FormattedMenu | "divider"> = [];
  if (menu != null) {
    menu.forEach((item) => {
      if (typeof item !== "string") {
        let newPath = item.rec_active_rule;
        const processId = item.rec_target_process_id;
        if(item.rec_active_rule != undefined && item.rec_active_rule.includes(",")) {
          const originalPath = item.rec_active_rule;
          newPath = originalPath.split(",")[0].trim()
        }
        const menuItem: FormattedMenu = {
          menu_icon: item.menu_icon,
          title: item.title,
          href: item.href,
          pageName: item.pageName,
          subMenu: item.subMenu,
          ignore: item.ignore,
          rec_active_rule: newPath,
          rec_target_process_id: processId,
          rec_menu_icon_parent: item.rec_menu_icon_parent
        };

        menuItem.active =
          ((route.forceActiveMenu !== undefined && item.pageName === route.forceActiveMenu)
            || (route.forceActiveMenu === undefined && ('/management' + newPath === window.location.pathname || '/management' + newPath + "/" + processId === window.location.pathname))
            || (item.subMenu && findActiveMenu(item.subMenu, route)))
          && !item.ignore;

        if (menuItem.subMenu) {
          menuItem.activeDropdown = findActiveMenu(item.subMenu, route);

          // Nested menu
          const subMenu: Array<FormattedMenu> = [];
          // @ts-ignore
          nestedMenu(menuItem.subMenu, route).map(
            (menu) => typeof menu !== "string" && subMenu.push(menu)
          );
          menuItem.subMenu = subMenu;
        }

        formattedMenu.push(menuItem);
      } else {
        formattedMenu.push(item);
      }
    });

    // console.log('formattedMenu', formattedMenu);

    return formattedMenu;
  }
};

// @ts-ignore
const linkTo = (menu: FormattedMenu, router: Router, event: Event) => {
  
  if (menu.subMenu && menu.subMenu.length > 0) {
    menu.activeDropdown = !menu.activeDropdown;
  } else {
    if (menu.pageName !== undefined) {
      event.preventDefault();

      let path = '';
      if (menu.rec_target_process_id != undefined && menu.rec_target_process_id != "n/a") {
        path = '/management' + menu.rec_active_rule + "/" + menu.rec_target_process_id
      } else {
        path = '/management' + menu.rec_active_rule
      }

      history.pushState(null, path, path);

      /*router.push({
        path
      });*/
    }
  }
};

const enter = (el: HTMLElement) => {
  slideDown(el, 300);
};

const leave = (el: HTMLElement) => {
  slideUp(el, 300);
};

export { nestedMenu, linkTo, enter, leave };
